import { useEffect, useRef, useState } from "react";

const CLOSED_SUSPENDED_SEC = 15;
const CLOSED_ROUND_OVER_SEC = 5;

/**
 * After evt_status becomes CLOSED:
 * 0–14s  → SUSPENDED !
 * 15–19s → ROUND OVER !
 * 20s+   → NEXT ROUND ! (until OPEN)
 */
export function useClosedPhaseOverlay(
  evtStatus,
  catMid,
  setShowBetSlipPopup
) {
  const [isSuspended, setIsSuspended] = useState(false);
  const [suspendedText, setSuspendedText] = useState("SUSPENDED !");
  const closedAtRef = useRef(null);
  const closedTickRef = useRef(null);
  const prevEvtStatusRef = useRef(null);
  const [closedElapsed, setClosedElapsed] = useState(0);

  useEffect(() => {
    if (!evtStatus) return;

    const prev = prevEvtStatusRef.current;

    if (evtStatus === "CLOSED") {
      if (prev !== "CLOSED" || closedAtRef.current === null) {
        closedAtRef.current = Date.now();
        setClosedElapsed(0);
      }
    } else if (evtStatus === "OPEN") {
      closedAtRef.current = null;
      setClosedElapsed(0);
      setIsSuspended(false);
    }

    prevEvtStatusRef.current = evtStatus;
  }, [evtStatus, catMid]);

  useEffect(() => {
    if (evtStatus !== "CLOSED" || !closedAtRef.current) {
      clearInterval(closedTickRef.current);
      return undefined;
    }

    const updateElapsed = () => {
      setClosedElapsed(
        Math.floor((Date.now() - closedAtRef.current) / 1000)
      );
    };

    updateElapsed();
    closedTickRef.current = setInterval(updateElapsed, 1000);

    return () => clearInterval(closedTickRef.current);
  }, [evtStatus, catMid]);

  useEffect(() => {
    if (evtStatus !== "CLOSED") return;

    setIsSuspended(true);
    if (typeof setShowBetSlipPopup === "function") {
      setShowBetSlipPopup(false);
    }

    if (closedElapsed < CLOSED_SUSPENDED_SEC) {
      setSuspendedText("SUSPENDED !");
    } else if (
      closedElapsed <
      CLOSED_SUSPENDED_SEC + CLOSED_ROUND_OVER_SEC
    ) {
      setSuspendedText("ROUND OVER !");
    } else {
      setSuspendedText("NEXT ROUND !");
    }
  }, [evtStatus, closedElapsed, setShowBetSlipPopup]);

  useEffect(() => () => clearInterval(closedTickRef.current), []);

  return { isSuspended, suspendedText };
}

export default useClosedPhaseOverlay;
